// Autogenerated by `yarn version-file`. DO NOT EDIT
export const VERSION = '1.17.0';
